import styled from 'styled-components'
import { Skeleton } from '~/components/shared'

export const Container = styled.div`
  position: relative;
`
export const SkeletonItem = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  margin-bottom: 10px;
  border-radius: 2px;
  margin-right: 8px;
`
export const ContentInLine = styled.div`
  display: flex;
  flex-direction: row;
`
